/**
 * Created by kevinqueeney on 22/09/2015.
 */
angular.module('qkr.inventory').directive('variantBuilder', ['variantService', 'inventoryService', '$timeout', 'appConfig', 'utils', 'gettextCatalog', function(variantService, inventoryService, $timeout, appConfig, utils, gettextCatalog) {
    return {
        restrict: 'E',
        template: require('../../inventory/directives/variantBuilder.html'),
        require: 'ngModel',
        scope: {
            merchant: '=',
            product: '=',
            isNewProduct: '=',
            isClonedProduct: '=',
            isEditable: '=',
            displayErrors: '=',
            variantBuilderApi: '='
        },
        link(scope, element, attrs, ngModel) {
            ngModel.$validators.variantConfig = function(modelValue) {
                return validateVariantSets(modelValue);
            };

            scope.selectVariantType = function(selectedVariantType, oldVariantTypeText) {
                hideErrors();

                if (selectedVariantType != null && selectedVariantType != undefined) {
                    let foundVariantType = false;

                    // Disable the selected variant type so as not to create duplicates.
                    angular.forEach(scope.variantConfig.addVariantTypes, (variantTypeInArray) => {
                        if (!foundVariantType) {
                            if (selectedVariantType.id == variantTypeInArray.id) {
                                variantTypeInArray.disabled = true;
                                foundVariantType = true;
                            }
                        }
                    });

                    // If the variant type hasn't been found in the array of variant
                    // Types then it's new. Add it to the list and disable it.
                    if (!foundVariantType && selectedVariantType.justCreated == true) {
                        // Remove the (Create New) from the String
                        selectedVariantType.text = variantService.removeAppendedCreateNewVariantTypeMarkerText(selectedVariantType.text);
                        selectedVariantType.justCreated = false;
                        selectedVariantType.disabled = true;
                        scope.variantConfig.addVariantTypes.push(selectedVariantType);
                    }

                    if (oldVariantTypeText != null && !utils.hasNoValue(oldVariantTypeText)) {
                        variantService.changeVariantType(scope.variantConfig.variantInfrastructure, oldVariantTypeText, selectedVariantType.text);
                        scope.product.variants = variantService.getVariantsFromInfrastructure(scope.variantConfig.variantInfrastructure);
                        scope.variantConfig.variantTitleList = variantService.getVariantTitleListFromInfrastructure(scope.variantConfig.variantInfrastructure);
                    }

                    createBlankVariantSetIfItDoesntExist();
                    disableSelectedVariantTypes();

                    ngModel.$validate();
                }
            };

            scope.removeVariantSet = function(variantSetToBeRemoved) {
                hideErrors();

                if (scope.errors && scope.errors.variantSets) {
                    delete (scope.errors.variantSets);
                }

                // Remove the variantSet based on it's variantType Id.
                let removalIndex = -1;
                for (let index = 0; index < scope.variantConfig.variantSets.length; index++) {
                    const variantSet = scope.variantConfig.variantSets[index];
                    if (variantSet.variantType != null && variantSet.variantType.id == variantSetToBeRemoved.variantType.id) {
                        removalIndex = index;
                        break;
                    }
                }

                if (removalIndex != -1) {
                    scope.variantConfig.variantSets.splice(removalIndex, 1);
                }

                createBlankVariantSetIfItDoesntExist();
                disableSelectedVariantTypes();

                ngModel.$validate();
            };

            scope.addVariant = function(newVariant) {
                hideErrors();

                const uniquenessValidationResult = variantService.isVariantUnique(scope.variantConfig.variantInfrastructure, newVariant);

                if (!uniquenessValidationResult.valid) {
                    angular.forEach(uniquenessValidationResult.errors, (error) => {
                        if (error.errorCode == 'sku') {
                            scope.newVariantErrors.sku = error.errorText;
                        } else if (error.errorCode == 'variantDetails') {
                            scope.newVariantErrors.newVariantType = error.errorText;
                        }
                    });

                    return;
                }

                const validationResult = variantService.validateVariant(newVariant, scope.product.stockTrackingEnabled);

                if (!validationResult.valid) {
                    scope.newVariantErrors = {};
                    angular.forEach(validationResult.errors, (error) => {
                        if (error.errorCode == 'variantDetailValue') {
                            scope.newVariantErrors.newVariantType = error.errorText;
                        } else if (error.errorCode == 'stock') {
                            scope.newVariantErrors.stock = error.errorText;
                        } else if (error.errorCode == 'amountMinorUnits') {
                            scope.newVariantErrors.price = error.errorText;
                        }
                    });

                    return;
                }

                variantService.addNewVariant(scope.variantConfig.variantInfrastructure, newVariant);
                refreshVariantSets();
                scope.newVariantObject = emptyVariantObject();
                scope.updateMaxMinPrices();

                ngModel.$validate();
            };

            scope.removeVariant = function(removeVariant) {
                hideErrors();

                variantService.removeVariant(scope.variantConfig.variantInfrastructure, scope.variantConfig.skusInUse, removeVariant);
                if (variantService.variantSetsHaveChanged(scope.variantConfig.variantInfrastructure, scope.variantConfig.variantSets)) {
                    refreshVariantSets();
                    createBlankVariantSetIfItDoesntExist();
                }
                scope.variantConfig.variantTitleList = variantService.getVariantTitleListFromInfrastructure(scope.variantConfig.variantInfrastructure);
                scope.updateMaxMinPrices();
                ngModel.$validate();
            };

            scope.canAddVariant = function() {
                if (scope.variantConfig != null) {
                    const validVariantSets = variantService.getValidVariantSets(scope.variantConfig.variantSets);
                    const variantSetThreshold = 2;
                    let variantSetCount = 0;

                    for (let i = 0; i < validVariantSets.length; i++) {
                        const validVariantSet = validVariantSets[i];
                        if (validVariantSet.options.length > 0) {
                            variantSetCount++;
                        }
                    }

                    if (variantSetCount >= variantSetThreshold) {
                        return true;
                    }
                }

                return false;
            };

            scope.updateMaxMinPrices = function() {
                scope.product.variants = variantService.getVariantsFromInfrastructure(scope.variantConfig.variantInfrastructure);
                inventoryService.setMinMaxPriceVariantsOnProduct(scope.product);
            };

            $timeout(() => {
                init();
            });

            function init() {
                scope.variantConfig = ngModel.$modelValue;
                scope.newVariantObject = emptyVariantObject();

                scope.select2Options = {
                    selectVariant: variantService.getSelectVariantConfig(scope.variantConfig.variantInfrastructure),
                    defineVariant: variantService.getDefineVariantConfig()
                };

                createBlankVariantSetIfItDoesntExist();
                scope.updateMaxMinPrices();

                scope.deregisterVariantSetWatch = setupVariantSetWatch();

                createAPI(scope.variantBuilderApi);
            }

            function hideErrors() {
                scope.displayErrors = false;
            }

            function setUpErrors() {
                scope.errors = {};
                scope.newVariantErrors = {};

                if (scope.variantConfig != null) {
                    angular.forEach(scope.variantConfig.variantSets, (variantSet) => {
                        variantSet.errors = {};
                    });
                }
            }

            function validateVariantSets(variantConfig) {
                setUpErrors();

                let valid = true;
                const useableVariantSets = variantService.getValidVariantSets(variantConfig.variantSets);

                if (useableVariantSets.length == 0) {
                    scope.errors.noValidVariantSet = gettextCatalog.getString('Please create at least one variant set');
                    valid = false;
                }

                angular.forEach(useableVariantSets, (variantSet) => {
                    if (variantSet.variantType != null && variantSet.options == null || variantSet.options.length == 0) {
                        variantSet.errors.noValidOptions = gettextCatalog.getString('Please create at least one variant value');
                        valid = false;
                    }
                });
                return valid;
            }

            function setupVariantSetWatch() {
                const deregisterVariantSetWatch = scope.$watch('variantConfig.variantSets', (newVariantSets, oldVariantSets) => {
                    if (newVariantSets != oldVariantSets) {
                        const newVariantDefinitions = variantService.buildVariants(scope.variantConfig.variantInfrastructure, scope.variantConfig.skusInUse, scope.product, oldVariantSets, newVariantSets);

                        if (newVariantDefinitions != null) {
                            hideErrors();
                            scope.product.variants = newVariantDefinitions;
                            scope.variantConfig.addVariantTypes = variantService.getVariantTypesFromInfrastructure(scope.variantConfig.variantInfrastructure);
                            scope.variantConfig.variantTitleList = variantService.getVariantTitleListFromInfrastructure(scope.variantConfig.variantInfrastructure);
                            scope.newVariantObject = emptyVariantObject();
                            scope.updateMaxMinPrices();

                            if (variantService.variantSetsHaveChanged(scope.variantConfig.variantInfrastructure, scope.variantConfig.variantSets)) {
                                $timeout(() => {
                                    refreshVariantSets();
                                });
                            }

                            ngModel.$validate();
                        }
                    }
                }, true);

                return deregisterVariantSetWatch;
            }

            function emptyVariantObject() {
                const variantObject = {};
                variantObject.variantDetails = [];

                angular.forEach(scope.variantConfig.variantTitleList, (variantTitle) => {
                    const newVariant = {
                        variantValue: '',
                        variantLabel: variantTitle
                    };
                    variantObject.variantDetails.push(newVariant);
                });

                if (scope.product.stockQuantity != null) {
                    variantObject.stockQuantity = angular.copy(scope.product.stockQuantity);
                }

                return variantObject;
            }

            function disableSelectedVariantTypes() {
                angular.forEach(scope.variantConfig.addVariantTypes, (variantType) => {
                    variantType.disabled = false;

                    angular.forEach(scope.variantConfig.variantSets, (variantSet) => {
                        if (variantSet.variantType != null && variantSet.variantType.id == variantType.id) {
                            variantType.disabled = true;
                        }
                    });
                });
            }

            function createBlankVariantSetIfItDoesntExist() {
                $timeout(() => {
                    // Add a blank variant set so the next record displays - but only if a
                    // Blank record doesn't already exist
                    if (scope.variantConfig.variantSets.length < scope.variantConfig.maxVariantSets) {
                        let foundBlankVariantType = false;
                        angular.forEach(scope.variantConfig.variantSets, (variantSet) => {
                            if (variantSet.variantType == null) {
                                foundBlankVariantType = true;
                            }
                        });

                        if (!foundBlankVariantType) {
                            const variantSet = {};
                            variantSet.id = variantService.generateVariantSetId(scope.variantConfig.variantSets);
                            variantSet.variantType = null;
                            variantSet.options = null;
                            variantSet.optionColour = variantService.getNextAvailableOptionColour(scope.variantConfig.variantSets);

                            scope.variantConfig.variantSets.push(variantSet);
                        }
                    }
                });
            }

            function refreshVariantSets() {
                // Don't animate the rows that are leaving.
                disableAnimationForClass('.select2input');
                scope.deregisterVariantSetWatch();

                const splicedVariantSets = scope.variantConfig.variantSets.splice(0, scope.variantConfig.variantSets.length);
                const newVariantSets = variantService.getVariantSetsFromInfrastructure(scope.variantConfig.variantInfrastructure);

                // Preserve empty variant sets
                angular.forEach(splicedVariantSets, (splicedVariantSet, index) => {
                    if (splicedVariantSet.options == null || splicedVariantSet.options.length == 0) {
                        newVariantSets.splice(index, 0, angular.copy(splicedVariantSet));
                    }
                });

                scope.variantConfig.variantSets = newVariantSets;

                $timeout(() => {
                    scope.deregisterVariantSetWatch = setupVariantSetWatch();
                });
            }

            function disableAnimationForClass(className) {
                const unAnimateableElements = angular.element(element[0].querySelectorAll(className));
                angular.forEach(unAnimateableElements, (unAnimateableElement) => {
                    angular.element(unAnimateableElement).addClass('no-animate');
                });
            }

            function createAPI(apiObject) {
                apiObject.deleteAllVariants = function() {
                    angular.forEach(scope.variantConfig.variantSets, (variantSet) => {
                        if (variantSet != null && variantSet.variantType != null) {
                            $timeout(() => {
                                scope.removeVariantSet(variantSet);
                            });
                        }
                    });
                };
            }
        }
    };
}]);



// WEBPACK FOOTER //
// ./src/inventory/directives/variantBuilder.js